import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useAsyncAction } from 'app/services';
import { transportCommandSend } from 'app/store/map';
import React from 'react';
import { useSelector } from 'react-redux';

const MapTransportConditionTerminalList = () => {
  const { id, sim0, sim1, conditions } = useSelector((state) => state.map.transportSelectedItem);
  const { asyncAction: commandSubmit } = useAsyncAction(transportCommandSend);

  const handleResetTerminal = () => {
    commandSubmit(id, 'reset');
  };

  return (
    <List
      disablePadding
      sx={(theme) => ({
        '.MuiListItem-root': {
          padding: theme.spacing(0),
          '.MuiListItemButton-root': {
            padding: theme.spacing(1, 2),
            overflow: 'hidden',
            '&:after': {
              content: '""',
              width: '100%',
              height: '1px',
              bgcolor: theme.palette.divider,
              position: 'absolute',
              bottom: '0',
            },
            '&:hover': {
              bgcolor: 'transparent',
            },
            '&.MuiListItemButton-primary': {
              '.MuiListItemText-root': {
                color: theme.palette.primary.main,
              },
            },
            '&.MuiListItemButton-error': {
              '.MuiListItemText-root': {
                color: theme.palette.error.main,
              },
            },
            '.MuiListItemText-root': {
              display: 'flex',
              margin: theme.spacing(0),
              justifyContent: 'space-between',
              '.MuiTypography-root': {
                lineHeight: '24px',
              },
            },
          },
          '&:last-of-type': {
            '.MuiListItemButton-root:after': {
              display: 'none',
            },
          },
        },
      })}>
      <ListItem>
        <ListItemButton dense disableRipple>
          {conditions.length !== 0 && (
            <ListItemText
              primary='Последняя активная СИМ'
              secondary={
                {
                  0: sim0 ? `СИМ_1: ${sim0}` : 'Номер не задан',
                  1: sim1 ? `СИМ_2: ${sim1}` : 'Номер не задан',
                  '-1': 'Неопределена',
                }[conditions[conditions.length - 1].data.active_sim]
              }
            />
          )}
        </ListItemButton>
      </ListItem>
      <ListItem onClick={handleResetTerminal}>
        <ListItemButton dense className='MuiListItemButton-error'>
          <ListItemText primary='Перезагрузить терминал' />
        </ListItemButton>
      </ListItem>
      <ListItem>
        <ListItemButton dense className='MuiListItemButton-error'>
          <ListItemText primary='Перезагрузить терминал по СМС' />
        </ListItemButton>
      </ListItem>
      <ListItem>
        <ListItemButton dense className='MuiListItemButton-primary'>
          <ListItemText primary='Переключить на использование только сим0' />
        </ListItemButton>
      </ListItem>
      <ListItem>
        <ListItemButton dense className='MuiListItemButton-primary'>
          <ListItemText primary='Переключить на использование только сим1' />
        </ListItemButton>
      </ListItem>
      <ListItem>
        <ListItemButton dense className='MuiListItemButton-primary'>
          <ListItemText primary='Выбрать автоматическое переключение сим' />
        </ListItemButton>
      </ListItem>
    </List>
  );
};

export default MapTransportConditionTerminalList;
